
"use strict";


class InviteUserDialog_Ctrl {


    constructor( $scope, $mdDialog, $http, $mdToast, email, $state ) {

        this.scope = $scope;
        this.$http = $http;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.$state = $state;
        $scope.buttonDisabled = false;


        ////Attach dependicies to class root
        $scope.$mdDialog = $mdDialog;

        //Close dialog
        $scope.hideDailog = () => {
            this.cancelButton();
        };

        $scope.send = () => {
            let data = {
                email: $scope.email,
                role_ids: $scope.role_ids
            };

            this.save(data);
        };

        $scope.email = email;

        this.$http.get('organisation/user-subscription').then((response) => {
            $scope.maxreached = response.data.maxReached;
        });

    }

    cancelButton () {
        this.$mdDialog.cancel();
    }

    save (data) {
        this.scope.buttonDisabled = true;

        this.$http.post('/invite', data).then(() => {
            this.$mdToast.show(
                this.$mdToast.simple()
                    .content('User has been invited')
                    .position('top right')
                    .hideDelay(3000)
            );
            this.scope.buttonDisabled = false;
            this.$mdDialog.hide();
            this.$state.go(this.$state.current, {}, {'reload':true});
        }, ( errors )=> {
            errors = errors.data;
            Object.getOwnPropertyNames(errors).forEach(( fieldName ) => {
                errors[fieldName].forEach(( message ) => {
                    this.$mdToast.show(
                        this.$mdToast.simple()
                            .content('Error: ' + message)
                            .position('top right')
                            .hideDelay(3000)
                    );
                });
            });
            this.scope.buttonDisabled = false;
        });
    }

}


/*
 * Inject dependicies
 */
InviteUserDialog_Ctrl.$inject = ['$scope', '$mdDialog', '$http', '$mdToast', 'email', '$state'];


/*
 * Browsify connection: execute controller
 */
module.exports = InviteUserDialog_Ctrl;
